import React from "react";
import { SIGNUP_LANGUAGE_SESSION_KEY, DEFAULT_LANGUAGE } from "features/common";
import { getSessionStorageValue, setSessionStorageValue } from "commons/utils";

const SYSTEM_LANGUAGES = ["en", "fr", "nl", "es", "pt"] as const;

export type TSystemLanguage = (typeof SYSTEM_LANGUAGES)[number];

function isSystemLanguage(lang: string): lang is TSystemLanguage {
  return SYSTEM_LANGUAGES.includes(lang as TSystemLanguage);
}

export function useSystemLanguage(languageQuery?: string | null) {
  const languageCode = React.useMemo(() => {
    const storedValue = getSessionStorageValue(SIGNUP_LANGUAGE_SESSION_KEY);
    const paramValue = languageQuery?.trim().toLowerCase();

    if (paramValue && isSystemLanguage(paramValue)) {
      return paramValue;
    }

    if (storedValue && isSystemLanguage(storedValue)) {
      return storedValue;
    }

    return DEFAULT_LANGUAGE.code;
  }, [languageQuery]);

  React.useEffect(() => {
    if (languageQuery && getSessionStorageValue(SIGNUP_LANGUAGE_SESSION_KEY) !== languageCode) {
      setSessionStorageValue(SIGNUP_LANGUAGE_SESSION_KEY, languageCode);
    }
  }, [languageCode, languageQuery]);

  return languageCode;
}
